// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + "." + "8f9f1e89ccb9425a1576" + ".js";
};